import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=1e221cb7&scoped=true&"
import script from "./Comment.vue?vue&type=script&lang=js&"
export * from "./Comment.vue?vue&type=script&lang=js&"
import style0 from "./Comment.vue?vue&type=style&index=0&id=1e221cb7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e221cb7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e221cb7')) {
      api.createRecord('1e221cb7', component.options)
    } else {
      api.reload('1e221cb7', component.options)
    }
    module.hot.accept("./Comment.vue?vue&type=template&id=1e221cb7&scoped=true&", function () {
      api.rerender('1e221cb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ispforum/forum/Comment.vue"
export default component.exports